module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["container"]
  }, [(_vm.show) ? _c('dof-overlay', {
    attrs: {
      "show": _vm.show,
      "hasAnimation": false
    }
  }) : _vm._e(), (_vm.show) ? _c('div', {
    staticClass: ["dofModalWrapper"],
    on: {
      "click": _vm.layoutClick
    }
  }, [_c('div', {
    staticClass: ["modal-box"],
    style: _vm._modalStyle,
    on: {
      "click": function () {}
    }
  }, [_c('div', {
    staticClass: ["modal-content"],
    style: _vm.modalContentStyle
  }, [_vm._t("title", [(_vm.title) ? _c('text', {
    staticClass: ["content-title"]
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e()]), _vm._t("image", [(_vm.image) ? _c('image', {
    staticClass: ["content-image"],
    style: _vm.imgStyle,
    attrs: {
      "resize": "cover",
      "src": _vm.image
    }
  }) : _vm._e()]), _vm._t("content", [(_vm.content) ? _c('text', {
    staticClass: ["content-subtext"],
    style: {
      fontFamily: _vm._isColmo ? 'PingFangSC-Regular' : _vm.title ? 'PingFangSC-Regular' : 'PingFangSC-Medium',
      color: _vm._subTextColor
    }
  }, [_vm._v(_vm._s(_vm.content))]) : _vm._e()]), _vm._t("input", [(_vm.hasInput) ? _c('input', {
    staticClass: ["search-bar-input"],
    attrs: {
      "placeholder": _vm.placeholder,
      "upriseOffset": _vm.inputUpriseOffset,
      "value": (_vm.inputContent)
    },
    on: {
      "input": function($event) {
        _vm.inputContent = $event.target.attr.value
      }
    }
  }) : _vm._e()])], 2), (_vm.btnGroup && _vm.btnGroup.length == 0) ? _c('div', {
    staticClass: ["modal-footer"],
    style: {
      borderTopColor: _vm._modalFooterBorderColor
    }
  }, [(!_vm.single) ? _c('div', {
    staticClass: ["footer-btn", "cancel"],
    style: {
      borderRightColor: _vm._modalFooterBorderColor
    }
  }, [_c('text', {
    staticClass: ["btn-text"],
    style: {
      color: _vm._secondBtnColor
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _c('div', {
    staticClass: ["mask"],
    on: {
      "click": _vm.cancelClicked
    }
  })]) : _vm._e(), _c('div', {
    staticClass: ["footer-btn", "confirm"]
  }, [_c('text', {
    staticClass: ["btn-text"],
    style: {
      color: _vm.mainBtnColor ? _vm.mainBtnColor : _vm._isColmo ? '#B35336' : _vm._isDiablo ? '#0490d3' : '#00A4F2',
      fontFamily: _vm._isColmo ? 'PingFangSC-Regular' : 'PingFangSC-Medium'
    }
  }, [_vm._v(_vm._s(_vm.confirmText))]), _c('div', {
    staticClass: ["mask"],
    on: {
      "click": _vm.primaryClicked
    }
  })])]) : _vm._e(), (_vm.btnGroup && _vm.btnGroup.length > 0) ? _c('div', {
    staticClass: ["more-btn"]
  }, _vm._l((_vm.btnGroup), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: ["footer-more-btn"],
      style: {
        borderTopColor: _vm._modalFooterBorderColor
      }
    }, [_c('text', {
      staticClass: ["btn-text"],
      style: {
        color: item.color ? item.color : _vm._secondBtnColor
      }
    }, [_vm._v(_vm._s(item.text || item))]), _c('div', {
      staticClass: ["mask"],
      on: {
        "click": function($event) {
          _vm.moreBtnClicked(index, item)
        }
      }
    })])
  })) : _vm._e(), (_vm.closeIcon || _vm.isShowCloseIcon) ? _c('div', {
    staticClass: ["closeIconBox"],
    on: {
      "click": _vm.closeIconClick
    }
  }, [(_vm.closeIcon) ? _c('image', {
    staticClass: ["closeIcon"],
    attrs: {
      "src": _vm.closeIcon
    }
  }) : _c('dof-iconfont', {
    staticClass: ["closeIconFont"],
    attrs: {
      "code": '\u4725',
      "size": 48,
      "color": _vm._isColmo ? 'rgba(255,255,255,0.80)' : '#333'
    },
    on: {
      "dofIconFontClicked": _vm.closeIconClick
    }
  })], 1) : _vm._e()])]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-3a9973ca!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-modal/index.vue
// module id = 602
// module chunks = 0 1